import React, { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useVerifyByNameMutation } from "../../Redux/apis/ApiSlice";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import debounce from "lodash.debounce";
import { notification } from "antd";

const VerifyName = () => {
  const [verifyByName] = useVerifyByNameMutation();
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [bookings, setBookings] = useState([]);
  const location = useLocation();
  const { eventId, userId } = location.state || {};
  const navigate = useNavigate();

  // Function to fetch bookings with the given query
  const fetchBookings = async (searchQuery) => {
    if (searchQuery.length < 2) {
      setBookings([]); // Clear bookings if query is too short
      return;
    }

    try {
      setLoading(true);
      const response = await verifyByName({
        name: searchQuery,
        eventId: Number(eventId),
        userId: Number(userId),
      }).unwrap();

      setBookings(response.length ? response : []); // Update bookings based on response data
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Error fetching bookings:", err);
      setBookings([]); // Clear bookings in case of an error
      notification.error({
        message:
          err?.data?.error || "Failed to fetch bookings! Please try again.",
      });
    }
  };

  // Debounced version of fetchBookings to limit API calls while typing
  const debouncedFetchBookings = useCallback(
    debounce((value) => fetchBookings(value), 500),
    [eventId, userId]
  );

  // Handle query change and trigger debounced fetch
  const handleQueryChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    debouncedFetchBookings(value);
  };

  return (
    <div style={{ padding: "20px", maxWidth: "800px", margin: "auto" }}>
      {/* Search Section */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
      >
        <TextField
          label="Search by booking name..."
          variant="outlined"
          value={query}
          onChange={handleQueryChange}
          fullWidth
          style={{ marginRight: "10px" }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => fetchBookings(query)}
          style={{ height: "56px" }}
        >
          Search
        </Button>
      </div>

      {/* Results Section */}
      <Grid container spacing={3}>
        {bookings.length > 0 ? (
          bookings.map((booking, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card
                style={{ backgroundColor: "#f9f9f9", borderRadius: "10px" }}
              >
                <CardContent>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    {booking?.ticketName || "No Name Provided"}
                  </Typography>
                  <Typography color="textSecondary">
                    {booking?.eventDetails?.eventName || "No Email Provided"}
                  </Typography>
                  <Typography color="textSecondary">
                    Status: {booking?.scanned ? "Already Scanned" : "Not Scanned" || "No Date Provided"}
                  </Typography>
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{
                      marginTop: "10px",
                      color: "#1976d2",
                      border: "1px solid #1976d2",
                    }}
                    onClick={() =>
                      navigate(`/DetailByNameInfo`, {
                        state: { booking, eventId, userId },
                      })
                    }
                  >
                    Verification Details
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Typography
            color="textSecondary"
            style={{ textAlign: "center", width: "100%", marginTop: "1rem" }}
          >
            {loading ? "Loading..." : "No bookings found."}
          </Typography>
        )}
      </Grid>
    </div>
  );
};

export default VerifyName;
